import React from 'react';

import AccentCard from '~/components/ClaimPage/CliveApp/CliveNotifications/AccentCard';
import type { AccentVariant } from '~/components/ClaimPage/CliveApp/CliveNotifications/accents';
import { ACCENT_CONFIG } from '~/components/ClaimPage/CliveApp/CliveNotifications/accents';
import type { StpNotification } from '~/components/ClaimPage/CliveApp/CliveNotifications/types';

import { LOG_MESSAGE_VISIBLE_LINES } from '../../constants';

interface AccentEntryProps {
  notification: StpNotification;
  accent: AccentVariant;
}

/**
 * An entry the claim's reader should not scroll past: a milestone, a pending step, or an error.
 * The one kind of narration the log draws as a card.
 *
 * The variant's glyph sits on the left edge and its colour frames the card, so a reader scrolling
 * past eighty lines of narration can find the handful of moments that changed the claim without
 * reading any of them.
 */
const AccentEntry: React.FC<AccentEntryProps> = ({ notification, accent }) => {
  const { Icon, iconColor } = ACCENT_CONFIG[accent];

  return (
    <div className="flex gap-12">
      <div className="flex w-20 shrink-0 justify-center pt-2">
        <Icon size={14} iconColor={iconColor} />
      </div>
      <div className="min-w-0 flex-1">
        <AccentCard notification={notification} accent={accent} visibleLines={LOG_MESSAGE_VISIBLE_LINES} />
      </div>
    </div>
  );
};

export default AccentEntry;
